export const CustomerModelModule = angular
    .module('app.services.model.models.customer', [])
    .value('customerModel', {
        contactInformation: {
            firstName: 'String',
            lastName: 'String',
            phoneNumber: 'String',
            address: 'String'
        },
        merchantNote: 'String',
        tags: 'Array',
        emailAddress: 'String',
        firstName: 'String',
        lastName: 'String',
        company: 'String',
        phoneNumber: 'String',
        revision: 'Number',
        textMessageOptIn: 'Boolean',
        emailOptIn: 'Boolean',
        auditLogId: 'String',
        orderCount: 'Number',
        ordersTotalPrice: 'Number',
        averageOrderPrice: 'Number',
        isRepeat: 'Boolean',
        marketToCustomer: ['Boolean', true],
        tenant: 'String',
        avalaraEntityUseCode: 'String'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/customer.model.js